// @flow

import React from 'react';
import PropTypes from 'prop-types';

import {makeStyles, Typography} from '@material-ui/core';

import wsspSaleImg from '../../../../../../assets/img/product-page/wssp-sale.png';
import {colors} from '../../../../../../assets/styles/colors';
import CustomModal from '../../../../../../elements/CustomModal/CustomModal';

import type {Theme} from '@material-ui/core';
type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 360,
    maxWidth: '100%',
    padding: theme.spacing(4, 1, 2, 1),
    overflowX: 'hidden',
    [theme.breakpoints.up('md')]: {
      width: 600,
    },
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: '#313135',
  },
  text: {
    color: colors.grey800,
    fontSize: 16,
    fontWeight: 400,
  },
  imageWrap: {
    margin: theme.spacing(2, 0, 1, 0),
    width: '100%',
    '& img': {
      maxWidth: '100%',
    },
  },
}));

export default function WsspSaleModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();

  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      className={classes.modal}
    >
      <div className={classes.root}>
        <Typography className={classes.title} align="center" gutterBottom>
          Pedir por whatsapp
        </Typography>
        <Typography align="center" className={classes.text} gutterBottom>
          Cuando el comprador hace click al botón se abre el modal de whatsapp
          con el detalle del producto.
        </Typography>

        <div className={classes.imageWrap}>
          <img src={wsspSaleImg} alt="add to cart" />
        </div>
      </div>
    </CustomModal>
  );
}

WsspSaleModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
